/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Style_Guide_Id_Required_ErrorInputs */

const en_iframe_remote_style_guide_id_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style guide ID is required`)
};

const fr_iframe_remote_style_guide_id_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID du guide de style requis`)
};

const de_iframe_remote_style_guide_id_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Styleguide-ID ist erforderlich.`)
};

const it_iframe_remote_style_guide_id_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È richiesto l'ID della guida di stile`)
};

const ru_iframe_remote_style_guide_id_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Требуется идентификатор руководства по стилю.`)
};

const es_iframe_remote_style_guide_id_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se requiere identificación de la guía de estilo`)
};

const zh_cn2_iframe_remote_style_guide_id_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`样式指南 ID 为必填项`)
};

const ja_iframe_remote_style_guide_id_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイルガイドIDが必要です`)
};

const hi_iframe_remote_style_guide_id_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टाइल गाइड आईडी आवश्यक है`)
};

const pt_pt2_iframe_remote_style_guide_id_required_error = /** @type {(inputs: Iframe_Remote_Style_Guide_Id_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É necessário o ID do guia de estilo.`)
};

/**
* | output |
* | --- |
* | "Style guide ID is required" |
*
* @param {Iframe_Remote_Style_Guide_Id_Required_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_style_guide_id_required_error = /** @type {((inputs?: Iframe_Remote_Style_Guide_Id_Required_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Style_Guide_Id_Required_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_style_guide_id_required_error(inputs)
	if (locale === "de") return de_iframe_remote_style_guide_id_required_error(inputs)
	if (locale === "it") return it_iframe_remote_style_guide_id_required_error(inputs)
	if (locale === "ru") return ru_iframe_remote_style_guide_id_required_error(inputs)
	if (locale === "es") return es_iframe_remote_style_guide_id_required_error(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_style_guide_id_required_error(inputs)
	if (locale === "ja") return ja_iframe_remote_style_guide_id_required_error(inputs)
	if (locale === "hi") return hi_iframe_remote_style_guide_id_required_error(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_style_guide_id_required_error(inputs)
	return en_iframe_remote_style_guide_id_required_error(inputs)
});